import { summerPromo2026ExpirationMs } from 'reactApp/appHelpers/featuresHelpers/features/summerPromo2026';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type {
    StoredTariffData,
    SummerCampaign2026ModalProps,
    TariffConfig,
    TariffKey,
    TouchTariffConfig,
} from './SummerCampaign2026Modal.types';

const SUMMER_2026_PROMO_PATH = 'static/cloud/promo/summer2026';

export const tariffConfigs: Record<TariffKey, TariffConfig> = {
    '512GB': {
        tariffId: 'W512GB_1m_summer_campaign_mailspace26_discount_force_trial',
        startImg: `${cdnPackagesUrl}/${SUMMER_2026_PROMO_PATH}/summerSale2026FirstFrame512GB.png`,
        endImg: `${cdnPackagesUrl}/${SUMMER_2026_PROMO_PATH}/summerSale2026LastFrame512GB.png`,
        animation: `${cdnPackagesUrl}/${SUMMER_2026_PROMO_PATH}/summerSale2026Animation512GB.webm`,
        erid: '2Vtzqufxm1z',
    },
    '1TB': {
        tariffId: 'W1TB_1m_summer_campaign_mailspace26_discount_force_trial',
        startImg: `${cdnPackagesUrl}/${SUMMER_2026_PROMO_PATH}/summerSale2026FirstFrame1TB.png`,
        endImg: `${cdnPackagesUrl}/${SUMMER_2026_PROMO_PATH}/summerSale2026LastFrame1TB.png`,
        animation: `${cdnPackagesUrl}/${SUMMER_2026_PROMO_PATH}/summerSale2026Animation1TB.webm`,
        erid: '2VtzquykcQ8',
    },
};

export const touchTariffConfig: Record<TariffKey, TouchTariffConfig> = {
    '512GB': {
        startImg: `${cdnPackagesUrl}/${SUMMER_2026_PROMO_PATH}/summerSale2026TouchFirstFrame512GB.png`,
        endImg: `${cdnPackagesUrl}/${SUMMER_2026_PROMO_PATH}/summerSale2026TouchLastFrame512GB.png`,
        animation: `${cdnPackagesUrl}/${SUMMER_2026_PROMO_PATH}/summerSale2026Touch512GB.webm`,
    },
    '1TB': {
        startImg: `${cdnPackagesUrl}/${SUMMER_2026_PROMO_PATH}/summerSale2026TouchFirstFrame1TB.png`,
        endImg: `${cdnPackagesUrl}/${SUMMER_2026_PROMO_PATH}/summerSale2026TouchLastFrame1TB.png`,
        animation: `${cdnPackagesUrl}/${SUMMER_2026_PROMO_PATH}/summerSale2026Touch1TB.webm`,
    },
};

export const SUMMER_PROMO_2026_TARIFF_KEY = 'summer_promo_2026_selected_tariff';

export const isTariffDataExpired = (data: StoredTariffData): boolean => {
    const now = Date.now();
    return now - data.timestamp > summerPromo2026ExpirationMs;
};

export const openSummerCampaign2026Modal = (data?: SummerCampaign2026ModalProps) =>
    openPopupHelper({ popupName: popupNames.SUMMER_CAMPAIGN_2026_MODAL, data, onClose: data?.onClose });
